export default function AttachmentIco() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="3.75" fill="#7F56D9" />
      <path
        d="M6 9.46732C6 8.72058 6 8.34721 6.14533 8.062C6.27315 7.81111 6.47713 7.60714 6.72801 7.47931C7.01323 7.33398 7.3866 7.33398 8.13333 7.33398H10.4497C10.7758 7.33398 10.9389 7.33398 11.0923 7.37082C11.2283 7.40348 11.3584 7.45736 11.4777 7.53046C11.6123 7.61292 11.7276 7.72822 11.9582 7.95882L12.0418 8.04248C12.2724 8.27308 12.3877 8.38838 12.5223 8.47084C12.6416 8.54394 12.7717 8.59782 12.9077 8.63048C13.0611 8.66732 13.2242 8.66732 13.5503 8.66732H15.8667C16.6134 8.66732 16.9868 8.66732 17.272 8.81264C17.5229 8.94047 17.7269 9.14444 17.8547 9.39533C18 9.68054 18 10.0539 18 10.8007V14.534C18 15.2807 18 15.6541 17.8547 15.9393C17.7269 16.1902 17.5229 16.3942 17.272 16.522C16.9868 16.6673 16.6134 16.6673 15.8667 16.6673H8.13333C7.38659 16.6673 7.01323 16.6673 6.72801 16.522C6.47713 16.3942 6.27315 16.1902 6.14533 15.9393C6 15.6541 6 15.2807 6 14.534V9.46732Z"
        stroke="white"
        stroke-width="1.45455"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
